import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageHeaderSearchActionService } from '../../services/page-header-search-action.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-onboarding-portal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './onboarding-portal.component.html',
  styleUrls: ['./onboarding-portal.component.scss']
})
export class OnboardingPortalComponent implements OnInit, OnDestroy {
  isAdminOrPc = false;

  constructor(
    private router: Router,
    private pageHeaderService: PageHeaderSearchActionService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.pageHeaderService.clearPageConfig();
    const user = this.authService.getUser();
    this.isAdminOrPc = !!(user?.isAdmin || user?.isPc);
  }

  ngOnDestroy(): void {
    this.pageHeaderService.clearPageConfig();
  }

  navigateToEmployees(): void {
    this.router.navigate(['/onboarding/employees']);
  }

  navigateToEmailTemplates(): void {
    this.router.navigate(['/onboarding/email-templates']);
  }

  navigateToTaskTemplates(): void {
    this.router.navigate(['/onboarding/task-templates']);
  }
}
